import {z} from '@hono/zod-openapi';

/**
 * Why a national market's purchase price is, or is not, the tenant's (T20-142160). Only
 * `tenant` comes with `purchasePriceSource: "tenant"`; every other value comes with `"alpha"`.
 *
 * After `tenant`, the next three are expected states: the request named no tenant, the tenant holds no Price
 * Report licence, or it kept the defaults. The last four mean the tenant's configuration should
 * have priced the report and did not, which is the case the price-report SPA tells the customer
 * about.
 */
export const priceReportPurchasePriceSourceReasonSchema = z
  .enum([
    'tenant',
    'no_customer',
    'not_licensed',
    'not_configured',
    'dms_unavailable',
    'currency_unavailable',
    'alpha_costs_missing',
    'configuration_invalid',
  ])
  .openapi('PriceReportPurchasePriceSourceReason', {
    description:
      'Why the purchase price is or is not computed from the tenant configuration. `tenant`: it is. ' +
      '`no_customer`: the request has no tenant `customerId`, or names one the DMS does not know. ' +
      '`not_licensed`: the tenant has no Price Report licence. `not_configured`: the tenant kept the ' +
      'defaults. `dms_unavailable`: the DMS failed or timed out. `currency_unavailable`: the tenant ' +
      'currency differs from the report currency and the DMS answered no usable exchange rate. ' +
      '`alpha_costs_missing`: Alpha answered without the costs the calculation takes over. ' +
      '`configuration_invalid`: the configuration is incomplete or yields no valid price.',
  });

export type PriceReportPurchasePriceSourceReason = z.infer<
  typeof priceReportPurchasePriceSourceReasonSchema
>;
